<template>
  <div>
    <div class="box">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="storeData"
      >
        <ul class="store-list">
          <li v-for="(v, i) in storeList" :key="i">
            <div class="left">
              <img :src="v.imgs | imgsFilter" alt />
            </div>
            <div class="middle">
              <span class="title">{{ v.shopName }}</span>
              <span class="grey">
                总评分
                <i class="orange">{{ v.score }}</i>
              </span>
              <span class="grey ellis">
                <img
                  @click.stop="opLocation(v)"
                  style="width: 13px; height: 15px"
                  :src="require('@/assets/images/icon/detail-position.png')"
                  alt
                />{{ v.provice }}{{ v.city }}{{ v.district
                }}{{ v.detailAddress }}</span
              >
              <p class="tag">
                <span v-for="(item, index) in v.shopServiceList" :key="index">{{
                  item.shopTagName
                }}</span>
              </p>
            </div>
            <div class="right">
              <a :href="`tel:${v.mobile}`">
                <img
                  style="width: 15px; height: 15px"
                  :src="require('@/assets/images/icon/detail-phone.png')"
                  alt
                />
              </a>
              <span class="store-tag">{{ v.shopTypeName }}</span>
              <span class="grey">{{ v.distanceKm }}km</span>
              <!-- <div> -->
              <!-- <br />
              </div> -->
            </div>
          </li>
        </ul>
      </van-list>
    </div>
  </div>
</template>
<script>
export default {
  name: "moreCardShop",
  data () {
    return {
      storeList: [],
      page: 1,
      limit: 10,
      loading: false,
      finished: false
    };
  },
  mounted () {
    // this.storeData();
  },
  methods: {
    // 门店列表
    async storeData () {
      let param = {
        lbsLongitude: localStorage.getItem("lbsLongitude"),
        lbsLatitude: localStorage.getItem("lbsLatitude"),
        cardId: this.$route.query.id,
        page: this.page,
        limit: this.limit
      };

      try {
        this.$loading("加载中");
        let res = await this.request("/user/userCard/applyShopList", {
          ...param
        });
        // if (this.cardData.type === 1) {
        //   res = await this.request("/activity/activityShop/list", {
        //     ...param
        //   });
        // } else if (this.cardData.type === 2 || this.cardData.type === 3) {
        //   res = await this.request("/card/cardVerifyShop/list", {
        //     ...param, cardId: this.cardData.cardId
        //   });
        // }
        this.$loadingClose();
        let arr = res.List.map(it => {
          return { ...it, distanceKm: (it.distance / 1000).toFixed(2) };
        });
        this.storeList = [...this.storeList, ...arr];
        this.loading = false;
        // 全部加载完
        if (this.storeList.length >= res.TotalCount) {
          this.finished = true;
        }
        if (res.List.length < res.TotalCount) {
            this.page++;
        }
      } catch (e) {
        this.$loadingClose();
        this.$error(e.message);
      }
    },
    // 导航
    opLocation (v) {
      if (window.wx) {
        // {{res.provice}}{{res.city}}{{res.district}}{{res.detailAddress}}
        let address = v.provice + v.city + v.district + v.detailAddress;
        window.wx.openLocation({
          latitude: v.lbsLatitude, // 纬度，浮点数，范围为90 ~ -90
          longitude: v.lbsLongitude, // 经度，浮点数，范围为180 ~ -180。
          name: v.shopName, // 位置名
          address: address // 详细地址
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/style";
.box {
  padding: 15px;
}
.store-list {
  li {
    .flex-center();
    justify-content: space-between;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    .left {
      width: 80px;
      img {
        width: 80px;
        height: 80px;
      }
    }
    .middle {
      flex: 1;
      padding: 0 6px;
      span {
        display: block;
      }
      .grey {
        font-size: 12px;
        i {
          font-style: normal;
          color: #ff8939;
        }
      }
      .title {
        font-size: 14px;
        padding-bottom: 5px;
      }
      .ellis {
        padding: 3px 0;
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .tag {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -1px;
        span {
          box-sizing: border-box;
          //width: calc(~"25% - " 3px);
          margin: 1px;
          border: 1px solid #ccc;
          color: #585858;
          border-radius: 3px;
          text-align: center;
          font-size: 11px;
        }
      }
    }
    .right {
      height: 80px;
      text-align: center;
      span {
        font-size: 10px;
      }
      .store-tag {
        margin: 10px 0 15px 0;
        white-space: nowrap;
        background: #0096ff;
        border-radius: 3px;
        color: #fff;
        font-size: 10px;
        padding: 1px 2px;
        opacity: 0.8;
        display: block;
        margin-bottom: 3px;
        text-align: center;
      }
    }
  }
}
</style>